import {
  MobilityFormFamily,
  PersonalCareFormFamily,
  MealsFormFamily,
  MedicationsFormFamily,
  ChoresFormFamily,
  CognitiveAidFormFamily,
} from './family';
import {
  MobilityFormSelf,
  PersonalCareFormSelf,
  MealsFormSelf,
  MedicationsFormSelf,
  ChoresFormSelf,
  CognitiveAidFormSelf,
} from './self';

export const IntakeFormsFamily = [
  MobilityFormFamily,
  PersonalCareFormFamily,
  MealsFormFamily,
  MedicationsFormFamily,
  ChoresFormFamily,
  CognitiveAidFormFamily,
];

export const IntakeFormsSelf = [
  MobilityFormSelf,
  PersonalCareFormSelf,
  MealsFormSelf,
  MedicationsFormSelf,
  ChoresFormSelf,
  CognitiveAidFormSelf,
];

export {
  MobilityFormFamily,
  PersonalCareFormFamily,
  MealsFormFamily,
  MedicationsFormFamily,
  ChoresFormFamily,
  CognitiveAidFormFamily,
  MobilityFormSelf,
  PersonalCareFormSelf,
  MealsFormSelf,
  MedicationsFormSelf,
  ChoresFormSelf,
  CognitiveAidFormSelf,
};
